import { SsrNavigator } from '../components/SsrNavigator';

export const ssrRoute = {
  name: 'ssr',
  path: '/ssr',
  exact: true,
  component: SsrNavigator,
  resources: [],
};
